import { SVGProps } from 'react';

const SvgTransgender = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M128 24c0-13.3-10.7-24-24-24H24C10.7 0 0 10.7 0 24v80c0 13.3 10.7 24 24 24s24-10.7 24-24V81.9L78.1 112l-7 7c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l7-7 15.2 15.2C107.6 187.7 96 220.5 96 256c0 80.2 59 146.6 136 158.2V432h-16c-13.3 0-24 10.7-24 24s10.7 24 24 24h16v8c0 13.3 10.7 24 24 24s24-10.7 24-24v-8h16c13.3 0 24-10.7 24-24s-10.7-24-24-24h-16v-17.8c77-11.6 136-78 136-158.2 0-35.5-11.6-68.3-31.2-94.9L464 81.9V104c0 13.3 10.7 24 24 24s24-10.7 24-24V24c0-13.3-10.7-24-24-24h-80c-13.3 0-24 10.7-24 24s10.7 24 24 24h22.1l-79.2 79.2C324.3 107.6 291.5 96 256 96s-68.3 11.6-94.9 31.2L145.9 112l7-7c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-7 7L81.9 48H104c13.3 0 24-10.7 24-24zm128 344c-61.9 0-112-50.1-112-112 0-29.8 11.7-56.9 30.7-77a21.976 21.976 0 0 0 4.3-4.3c20.1-19 47.2-30.7 77-30.7s56.9 11.7 77 30.7a21.976 21.976 0 0 0 4.3 4.3c19 20.1 30.7 47.2 30.7 77 0 61.9-50.1 112-112 112z" />
  </svg>
);
export default SvgTransgender;
